module.exports = __webpack_public_path__ + "img/icon-element-Claymore.31b7f355.webp";